import Loader from "../components/Loader";
import Header from "../components/Header";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import JobPerformance from "../components/Charts/JobPerformance";
import CostRevenueChart from "../components/Charts/CostRevenueChart";
import { fetchAnalytics } from "../redux/actions/servicePresetsActions";

const Analytics = () => {
  const dispatch = useDispatch();
  const [isToggle, setIsToggle] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState(1);
  const { isLoading, analyticsData } = useSelector(
    (state) => state.servicePresetsReducer,
  );
  const monthOptions = [
    { label: "Last 1 Month", value: 1 },
    { label: "Last 3 Months", value: 3 },
    { label: "Last 6 Months", value: 6 },
    { label: "Last 12 Months", value: 12 },
  ];
  useEffect(() => {
    dispatch(fetchAnalytics(selectedMonths));
  }, [selectedMonths]);
  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="analytics" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div class="ct_px_23 ct_mt_30 pb-5">
            <div class="">
              <div class="mb-5 d-flex ct_flex_col_575 gap-3 justify-content-between">
                <div className="dropdown ct_w_100_575">
                  <button
                    className="btn filter-dropdown ct_w_100_575 d-flex align-items-center gap-4 justify-content-between text-nowrap"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {
                      monthOptions.find(
                        (item) => item.value === selectedMonths
                      )?.label
                    }
                    <i className="fa-solid fa-angle-down"></i>
                  </button>

                  <ul className="dropdown-menu ct_custom_dropdown_filter">
                    {monthOptions.map((item) => (
                      <li
                        key={item.value}
                        className="ct_pointer"
                        onClick={() => setSelectedMonths(item.value)}
                      >
                        <a className="dropdown-item">
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* <div className="ct_w_100_575">
                  <a href="#" class="ct_orange_btn ct_w_100_575">
                    <svg
                      class="me-2"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.75 2.75H9.71163V4.125H4.125V17.875H17.875V12.375H19.25V19.25H2.75V2.75ZM13.7074 2.86H19.2665V8.25H17.8915V5.2085L11.3781 11.7219L10.406 10.7497L16.9194 4.23638H13.7074V2.86Z"
                        fill="white"
                      />
                    </svg>
                    Export{" "}
                  </a>
                </div> */}
              </div>

              <div class="row mb-2">
                <div class="col-xxl-3 col-xl-6 col-lg-6 col-sm-6 mb-4">
                  <div class="ct_white_bg ct_dash_card active">
                    <div class="d-flex align-items-center gap-3 justify-content-between">
                      <div>
                        <p class="mb-0">Total Revenue</p>
                        <h3 class="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
                          {analyticsData?.stats?.
                            total_revenue?.formatted}
                        </h3>
                      </div>
                      <div class="ct_dash_icon">
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.2503 12.5C18.3763 11.7674 17.2653 11.3786 16.1252 11.4063H8.79713C8.463 11.4147 8.13062 11.3556 7.81986 11.2326C7.5091 11.1095 7.22637 10.9251 6.98858 10.6902C6.75079 10.4553 6.56284 10.1749 6.43597 9.86567C6.30911 9.55646 6.24594 9.22482 6.25025 8.89063C6.2421 8.76054 6.2421 8.63008 6.25025 8.5C6.34877 7.90282 6.66191 7.36215 7.13086 6.97951C7.59981 6.59686 8.19232 6.39858 8.79713 6.42188H16.0159C16.6047 6.42136 17.1746 6.63001 17.6239 7.01063C18.0732 7.39125 18.3727 7.91908 18.469 8.5H20.8128C20.7146 7.29521 20.1667 6.17146 19.278 5.35217C18.3892 4.53289 17.2247 4.07806 16.0159 4.07812H13.5471V0.484375H11.594V4.07812H8.79713C7.58835 4.07806 6.42381 4.53289 5.53504 5.35217C4.64627 6.17146 4.09837 7.29521 4.00025 8.5C3.9921 8.63008 3.9921 8.76054 4.00025 8.89063C4.00025 9.52056 4.12432 10.1443 4.36539 10.7263C4.60646 11.3083 4.95979 11.8371 5.40522 12.2825C6.30481 13.1821 7.52491 13.6875 8.79713 13.6875H16.2034C16.5348 13.6792 16.8646 13.7373 17.1733 13.8584C17.482 13.9795 17.7633 14.1612 18.0006 14.3927C18.238 14.6242 18.4266 14.9009 18.5553 15.2065C18.6841 15.512 18.7504 15.8403 18.7503 16.1719C18.7653 16.3486 18.7653 16.5264 18.7503 16.7031C18.6262 17.2529 18.3189 17.7441 17.8788 18.0962C17.4387 18.4483 16.892 18.6403 16.3284 18.6406H8.98463C8.42103 18.6403 7.8743 18.4483 7.43421 18.0962C6.99412 17.7441 6.68681 17.2529 6.56275 16.7031H4.20338C4.33765 17.8771 4.89916 18.9607 5.7809 19.7473C6.66264 20.534 7.80298 20.9687 8.98463 20.9687H11.594V24.5156H13.5471V20.9687H16.2034C17.385 20.9687 18.5254 20.534 19.4071 19.7473C20.2888 18.9607 20.8503 17.8771 20.9846 16.7031V16.1719C20.9827 15.4701 20.8264 14.7773 20.5266 14.1427C20.2269 13.5081 19.7911 12.9472 19.2503 12.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xxl-3 col-xl-6 col-lg-6 col-sm-6 mb-4">
                  <div class="ct_white_bg ct_dash_card">
                    <div class="d-flex align-items-center gap-3 justify-content-between">
                      <div>
                        <p class="mb-0">Total Profit</p>
                        <h3 class="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
                          {analyticsData?.stats?.
                            total_profit?.formatted}
                        </h3>
                      </div>
                      <div class="ct_dash_icon">
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.16732 20.8337C3.5944 20.8337 3.10412 20.6298 2.69648 20.2222C2.28885 19.8146 2.08468 19.3239 2.08398 18.7503V6.25033C2.08398 5.67741 2.28815 5.18713 2.69648 4.77949C3.10482 4.37185 3.5951 4.16769 4.16732 4.16699H20.834C21.4069 4.16699 21.8975 4.37116 22.3059 4.77949C22.7142 5.18783 22.918 5.6781 22.9173 6.25033V18.7503C22.9173 19.3232 22.7135 19.8139 22.3059 20.2222C21.8982 20.6305 21.4076 20.8344 20.834 20.8337H4.16732ZM4.16732 18.7503H20.834V6.25033H4.16732V18.7503ZM10.4173 14.5837H7.29232C6.99718 14.5837 6.74996 14.6837 6.55065 14.8837C6.35135 15.0837 6.25135 15.3309 6.25065 15.6253C6.24996 15.9198 6.34996 16.1673 6.55065 16.368C6.75135 16.5687 6.99857 16.6684 7.29232 16.667H8.33398C8.33398 16.9621 8.43398 17.2097 8.63398 17.4097C8.83398 17.6097 9.08121 17.7094 9.37565 17.7087C9.67009 17.708 9.91767 17.608 10.1184 17.4087C10.3191 17.2094 10.4187 16.9621 10.4173 16.667H11.459C11.7541 16.667 12.0017 16.567 12.2017 16.367C12.4017 16.167 12.5013 15.9198 12.5007 15.6253V12.5003C12.5007 12.2052 12.4007 11.958 12.2007 11.7587C12.0007 11.5594 11.7534 11.4594 11.459 11.4587H8.33398V10.417H11.459C11.7541 10.417 12.0017 10.317 12.2017 10.117C12.4017 9.91699 12.5013 9.66977 12.5007 9.37533C12.5 9.08088 12.4 8.83366 12.2007 8.63366C12.0013 8.43366 11.7541 8.33366 11.459 8.33366H10.4173C10.4173 8.03852 10.3173 7.7913 10.1173 7.59199C9.91732 7.39269 9.67009 7.29269 9.37565 7.29199C9.08121 7.2913 8.83398 7.3913 8.63398 7.59199C8.43398 7.79269 8.33398 8.03991 8.33398 8.33366H7.29232C6.99718 8.33366 6.74996 8.43366 6.55065 8.63366C6.35135 8.83366 6.25135 9.08088 6.25065 9.37533V12.5003C6.25065 12.7955 6.35065 13.043 6.55065 13.243C6.75065 13.443 6.99787 13.5427 7.29232 13.542H10.4173V14.5837ZM16.8496 16.7451L18.3079 15.2868C18.3947 15.2 18.4166 15.1045 18.3736 15.0003C18.3305 14.8962 18.2479 14.8441 18.1257 14.8441H15.209C15.0875 14.8441 15.0052 14.8962 14.9621 15.0003C14.9191 15.1045 14.9406 15.2 15.0267 15.2868L16.485 16.7451C16.5371 16.7972 16.5979 16.8232 16.6673 16.8232C16.7368 16.8232 16.7975 16.7972 16.8496 16.7451ZM15.209 10.417H18.1257C18.2472 10.417 18.3298 10.3649 18.3736 10.2607C18.4173 10.1566 18.3954 10.0611 18.3079 9.97428L16.8496 8.51595C16.7975 8.46387 16.7368 8.43783 16.6673 8.43783C16.5979 8.43783 16.5371 8.46387 16.485 8.51595L15.0267 9.97428C14.9399 10.0611 14.9184 10.1566 14.9621 10.2607C15.0059 10.3649 15.0882 10.417 15.209 10.417Z"
                            fill="#23C0E8"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xxl-3 col-xl-6 col-lg-6 col-sm-6 mb-4">
                  <div class="ct_white_bg ct_dash_card">
                    <div class="d-flex align-items-center gap-3 justify-content-between">
                      <div>
                        <p class="mb-0">Jobs Completed</p>
                        <h3 class="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
                          {analyticsData?.stats?.
                            jobs_completed?.formatted}
                        </h3>
                      </div>
                      <div class="ct_dash_icon">
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.4663 21.8744H10.0059C6.27148 21.8744 4.40482 21.8744 3.2444 20.6921C2.08398 19.5098 2.08398 17.6066 2.08398 13.8014C2.08398 9.99622 2.08398 8.0931 3.2444 6.91081C4.40482 5.72852 6.27148 5.72852 10.0059 5.72852H13.9673C17.7017 5.72852 19.5694 5.72852 20.7298 6.91081C21.6225 7.82018 21.8277 9.15664 21.8757 11.4577"
                            stroke="#23C0E8"
                            stroke-width="1.8"
                            stroke-linecap="round"
                          />
                          <path
                            d="M16.668 5.72884L16.5638 5.40593C16.0482 3.80176 15.7909 2.99967 15.1773 2.54134C14.5628 2.08301 13.7482 2.08301 12.1159 2.08301H11.8419C10.2117 2.08301 9.39609 2.08301 8.78255 2.54134C8.16797 2.99967 7.91068 3.80176 7.39505 5.40593L7.29297 5.72884M17.8253 13.807C18.018 13.6299 18.1138 13.5413 18.2305 13.5413C18.3471 13.5413 18.443 13.6299 18.6357 13.807L19.3784 14.4913C19.468 14.5736 19.5128 14.6153 19.568 14.6351C19.6242 14.6559 19.6846 14.6538 19.8076 14.6486L20.8096 14.6091C21.068 14.5986 21.1971 14.5945 21.2857 14.6684C21.3742 14.7424 21.3919 14.8705 21.4263 15.1268L21.5638 16.1538C21.5805 16.2726 21.5878 16.3309 21.6169 16.383C21.6461 16.433 21.693 16.4695 21.7867 16.5434L22.5951 17.1788C22.7951 17.3372 22.8951 17.4153 22.9148 17.5278C22.9346 17.6403 22.8669 17.7486 22.7336 17.9653L22.1857 18.8476C22.1232 18.9486 22.0919 18.9997 22.0815 19.0559C22.0711 19.1122 22.0836 19.1716 22.1086 19.2882L22.3263 20.307C22.3784 20.557 22.4055 20.682 22.3482 20.782C22.2909 20.882 22.169 20.9216 21.9263 21.0007L20.9617 21.3143C20.8471 21.3518 20.7888 21.3705 20.744 21.408C20.6992 21.4466 20.6711 21.5007 20.6159 21.608L20.1451 22.5153C20.0253 22.7476 19.9648 22.8632 19.8555 22.9028C19.7461 22.9424 19.6263 22.8924 19.3846 22.7924L18.4596 22.4091C18.3461 22.3622 18.2898 22.3382 18.2305 22.3382C18.1711 22.3382 18.1148 22.3622 18.0013 22.4091L17.0763 22.7924C16.8346 22.8924 16.7148 22.9424 16.6055 22.9028C16.4961 22.8632 16.4357 22.7466 16.3159 22.5153L15.8451 21.608C15.7888 21.5007 15.7617 21.4466 15.7169 21.4091C15.6721 21.3716 15.6138 21.3518 15.4992 21.3153L14.5346 21.0007C14.2919 20.9216 14.1701 20.882 14.1128 20.782C14.0555 20.682 14.0815 20.558 14.1346 20.307L14.3534 19.2882C14.3773 19.1716 14.3898 19.1132 14.3794 19.057C14.3581 18.9816 14.3227 18.9109 14.2753 18.8486L13.7284 17.9653C13.593 17.7486 13.5263 17.6403 13.5461 17.5278C13.5659 17.4153 13.6659 17.3372 13.8659 17.1799L14.6742 16.5445C14.768 16.4695 14.8148 16.433 14.844 16.382C14.8732 16.3309 14.8805 16.2726 14.8961 16.1528L15.0346 15.1268C15.069 14.8716 15.0867 14.7424 15.1753 14.6684C15.2638 14.5945 15.393 14.5986 15.6513 14.6091L16.6544 14.6486C16.7763 14.6538 16.8367 14.6559 16.893 14.6351C16.9482 14.6143 16.993 14.5736 17.0826 14.4913L17.8253 13.807Z"
                            stroke="#23C0E8"
                            stroke-width="1.8"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xxl-3 col-xl-6 col-lg-6 col-sm-6 mb-4">
                  <div class="ct_white_bg ct_dash_card">
                    <div class="d-flex align-items-center gap-3 justify-content-between">
                      <div>
                        <p class="mb-2">Avg Job Value</p>
                        <h3 class="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_text_color_1B1C1C">
                          {analyticsData?.stats?.
                            avg_job_value?.formatted}
                        </h3>
                      </div>
                      <div class="ct_dash_icon">
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.7057 2.91515C11.0661 2.99952 10.2765 3.18077 9.15362 3.44015L7.87341 3.73598C6.9255 3.95473 6.27133 4.10681 5.77237 4.27765C5.29008 4.44327 5.01716 4.60577 4.81195 4.81202C4.60571 5.01723 4.4432 5.29015 4.27758 5.77244C4.10675 6.2714 3.95466 6.92452 3.73591 7.87348L3.44008 9.15265C3.18071 10.2766 2.99946 11.0662 2.91508 11.7058C2.83175 12.3287 2.85154 12.7506 2.96196 13.1339C3.07133 13.5172 3.27862 13.8849 3.67862 14.3693C4.09008 14.8672 4.66195 15.4412 5.47758 16.2568L7.38383 18.1631C8.79945 19.5787 9.80675 20.5839 10.6734 21.2443C11.5213 21.8922 12.1422 22.1349 12.7724 22.1349C13.4026 22.1349 14.0234 21.8922 14.8724 21.2443C15.738 20.5839 16.7463 19.5776 18.162 18.162C19.5786 16.7454 20.5838 15.7381 21.2453 14.8724C21.8911 14.0235 22.1349 13.4037 22.1349 12.7724C22.1349 12.1422 21.8922 11.5224 21.2442 10.6735C20.5838 9.80681 19.5776 8.79848 18.162 7.38285L16.2557 5.4766C15.4411 4.66202 14.8672 4.09015 14.3703 3.67869C13.8849 3.27869 13.5172 3.0714 13.1338 2.96202C12.7505 2.8516 12.3286 2.83285 11.7067 2.91515M11.5026 1.36619C12.2495 1.26723 12.9047 1.27035 13.5651 1.45994C14.2265 1.64952 14.7838 1.99431 15.3651 2.47348C15.9276 2.93806 16.5526 3.56306 17.3349 4.34535L19.3099 6.32035C20.6745 7.68494 21.7557 8.76619 22.487 9.7266C23.2411 10.7131 23.6984 11.6631 23.6984 12.7724C23.6984 13.8829 23.2411 14.8329 22.488 15.8193C21.7557 16.7797 20.6755 17.861 19.3099 19.2256L19.2265 19.3089C17.862 20.6735 16.7807 21.7547 15.8203 22.486C14.8338 23.2401 13.8828 23.6974 12.7734 23.6974C11.664 23.6974 10.714 23.2401 9.72654 22.487C8.76716 21.7547 7.68591 20.6745 6.32029 19.3089L4.34633 17.3329C3.56508 16.5516 2.93904 15.9256 2.47446 15.3641C1.99529 14.7818 1.6505 14.2245 1.46091 13.5641C1.27133 12.9026 1.26821 12.2474 1.36716 11.5006C1.46196 10.7776 1.66196 9.91514 1.90987 8.83806L2.22237 7.48077C2.43071 6.58181 2.59945 5.84848 2.8005 5.2641C3.01091 4.65265 3.27446 4.1391 3.70779 3.70577C4.14112 3.27244 4.65571 3.00785 5.26612 2.79952C5.8505 2.59744 6.58383 2.42869 7.48279 2.2214L8.84008 1.9089C9.91716 1.6589 10.7797 1.46098 11.5026 1.36515M9.88487 8.32765C9.64065 8.08343 9.30942 7.94622 8.96404 7.94622C8.61866 7.94622 8.28743 8.08343 8.0432 8.32765C7.79898 8.57187 7.66178 8.9031 7.66178 9.24848C7.66178 9.59386 7.79898 9.92509 8.0432 10.1693C8.16413 10.2902 8.30769 10.3862 8.46569 10.4516C8.62368 10.517 8.79302 10.5507 8.96404 10.5507C9.13505 10.5507 9.30439 10.517 9.46239 10.4516C9.62039 10.3862 9.76395 10.2902 9.88487 10.1693C10.0058 10.0484 10.1017 9.90483 10.1672 9.74683C10.2326 9.58883 10.2663 9.41949 10.2663 9.24848C10.2663 9.07746 10.2326 8.90812 10.1672 8.75013C10.1017 8.59213 10.0058 8.44857 9.88487 8.32765ZM6.938 7.22348C7.4752 6.68614 8.20385 6.38421 8.96367 6.38411C9.72348 6.38401 10.4522 6.68576 10.9896 7.22296C11.5269 7.76016 11.8288 8.48882 11.8289 9.24863C11.829 10.0084 11.5273 10.7372 10.9901 11.2745C10.4527 11.8119 9.72395 12.1137 8.96404 12.1137C8.20412 12.1137 7.47534 11.8119 6.938 11.2745C6.40066 10.7372 6.09878 10.0084 6.09878 9.24848C6.09878 8.48857 6.40066 7.76082 6.938 7.22348ZM13.5317 12.6099C13.2909 12.6191 13.0634 12.7228 12.8984 12.8985C12.4942 13.3026 12.6005 13.7058 12.714 13.8193C12.8286 13.9329 13.2317 14.0381 13.6349 13.6349C14.4515 12.8183 15.862 12.5474 16.7651 13.4506C17.4661 14.1516 17.4609 15.1579 17.0411 15.9547C17.1444 16.1049 17.1919 16.2864 17.1755 16.4679C17.1591 16.6494 17.0797 16.8194 16.9512 16.9486C16.8226 17.0777 16.653 17.1579 16.4716 17.1752C16.2902 17.1925 16.1084 17.1458 15.9578 17.0433C15.4904 17.2997 14.9481 17.3852 14.4245 17.2849C14.3239 17.2643 14.2284 17.224 14.1434 17.1665C14.0585 17.1089 13.9856 17.0352 13.9291 16.9495C13.8727 16.8638 13.8336 16.7678 13.8142 16.667C13.7948 16.5662 13.7955 16.4626 13.8161 16.362C13.8368 16.2615 13.877 16.166 13.9346 16.081C13.9922 15.996 14.0659 15.9232 14.1516 15.8667C14.2373 15.8102 14.3333 15.7712 14.4341 15.7518C14.5349 15.7324 14.6385 15.733 14.739 15.7537C14.9234 15.7922 15.2213 15.7329 15.4765 15.4766C15.8797 15.0724 15.7745 14.6693 15.6609 14.5558C15.5463 14.4422 15.1432 14.337 14.7401 14.7401C13.9234 15.5568 12.513 15.8276 11.6099 14.9245C10.9088 14.2235 10.914 13.2172 11.3338 12.4204C11.2306 12.2702 11.183 12.0887 11.1994 11.9072C11.2159 11.7257 11.2952 11.5557 11.4238 11.4265C11.5523 11.2974 11.722 11.2172 11.9034 11.1999C12.0848 11.1826 12.2665 11.2293 12.4172 11.3318C12.7713 11.1433 13.1599 11.0433 13.5474 11.0474C13.7546 11.0494 13.9525 11.1335 14.0977 11.2814C14.2428 11.4293 14.3233 11.6288 14.3213 11.836C14.3194 12.0432 14.2352 12.2411 14.0874 12.3863C13.9395 12.5314 13.7389 12.6119 13.5317 12.6099Z"
                            fill="#23C0E8"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-7 mb-3">
                  <div class="chart-box h-100">
                    <div class="chart-card">
                      <div class="chart-title ct_fs_16 ct_fw_600">
                        Revenue & Cost Trends
                      </div>
                      <div style={{ padding: 20, paddingLeft: 0 }}>
                        <CostRevenueChart
                          data={analyticsData?.revenue_cost_trends}
                        />
                      </div>
                      {/* <div id="revenuechart"></div> */}
                    </div>
                  </div>
                </div>

                <div class="col-lg-5 mb-3">
                  <div class="ct_border_20 ct_p_20 ct_white_bg h-100 profit_margin_progress_box">
                    <h6 class="ct_fs_16 ct_fw_600 ct_text_dark mb-3">
                      Profit Margin by Service Type
                    </h6>
                    <div class="ct_modal_divider"></div>
                    <div>
                      {analyticsData?.profit_margin_by_service?.map((item, index) => (
                        <div className="item-row mb-3" key={index}>
                          <div className="item-header d-flex justify-content-between gap-2 mb-1">
                            <span className="ct_fs_13 ct_fw_600 ct_text_dark">
                              {item.service_name}
                            </span>

                            <span className="amount ct_fs_13 ct_fw_400 ct_text_para">
                              {item.formatted_profit}
                            </span>
                          </div>

                          <div className="progress">
                            <div
                              className="progress-bar"
                              style={{
                                width: `${item.bar_width_percent}%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      ))}
                      {/* <div class="item-row">
                        <div class="item-header d-flex justify-content-between gap-2 mb-1">
                          <span class="ct_fs_13 ct_fw_600 ct_text_dark">
                            Engine & Propulsion
                          </span>
                          <span class="amount ct_fs_13 ct_fw_400 ct_text_para">
                            $141k
                          </span>
                        </div>
                        <div class="progress">
                          <div
                            class="progress-bar"
                            style={{ width: "75%" }}
                          ></div>
                        </div>
                      </div> */}

                      {/* Item 2 */}
                      <div class="item-row">
                        <div class="item-header  d-flex justify-content-between gap-2 mb-1">
                          <span class="ct_fs_13 ct_fw_600 ct_text_dark">
                            Electronics & Navigation
                          </span>
                          <span class="amount ct_fs_13 ct_fw_400 ct_text_para">
                            $141k
                          </span>
                        </div>
                        <div class="progress">
                          <div
                            class="progress-bar"
                            style={{ width: "40%" }}
                          ></div>
                        </div>
                      </div>

                      {/* Item 3 */}
                      <div class="item-row">
                        <div class="item-header d-flex justify-content-between gap-2 mb-1">
                          <span class="ct_fs_13 ct_fw_600 ct_text_dark">
                            Hull & Antifouling
                          </span>
                          <span class="amount ct_fs_13 ct_fw_400 ct_text_para">
                            $141k
                          </span>
                        </div>
                        <div class="progress">
                          <div
                            class="progress-bar"
                            style={{ width: "60%" }}
                          ></div>
                        </div>
                      </div>

                      {/* Item 4 */}
                      <div class="item-row">
                        <div class="item-header  d-flex justify-content-between gap-2 mb-1">
                          <span class="ct_fs_13 ct_fw_600 ct_text_dark">
                            Engine & Propulsion
                          </span>
                          <span class="amount ct_fs_13 ct_fw_400 ct_text_para">
                            $141k
                          </span>
                        </div>
                        <div class="progress">
                          <div
                            class="progress-bar"
                            style={{ width: "20%" }}
                          ></div>
                        </div>
                      </div>
                      {/* Item 5 */}
                      <div class="item-row">
                        <div class="item-header  d-flex justify-content-between gap-2 mb-1">
                          <span class="ct_fs_13 ct_fw_600 ct_text_dark">
                            Electrical Systems
                          </span>
                          <span class="amount ct_fs_13 ct_fw_400 ct_text_para">
                            $141k
                          </span>
                        </div>
                        <div class="progress">
                          <div
                            class="progress-bar"
                            style={{ width: "40%" }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cti_mt_25">
                <div class="row">
                  <div class="col-xl-4 col-md-6 mb-3">
                    <div class="chart-box h-100">
                      <div class="title ct_fs_16 ct_fw_600 ct_text_dark mb-3">
                        Job Performance
                      </div>

                      {/* Chart */}
                      {/* <div id="job-performance"></div> */}
                      <div style={{ padding: 20 }}>
                        <JobPerformance
                          data={
                            analyticsData?.job_performance || {}
                          }
                        />
                      </div>
                    </div>
                  </div>
                  {analyticsData?.top_technicians?.length && (
                    <div class="col-xl-4 col-md-6 mb-3">
                      <div class="ct_border_20 ct_p_20 ct_white_bg h-100 top-technician-box">
                        <h3 class="ct_fs_16 ct_fw_600 ct_text_dark mb-3">
                          Top Technicians
                        </h3>
                        {analyticsData?.top_technicians?.map((item, index) => (
                          <div class="d-flex justify-content-between gap-2 align-items-center mb-3 flex-wrap">
                            <div class="d-flex gap-2 align-items-center">
                              <div>
                                <img
                                  src={
                                    item?.profile_image || "user_profile.png"
                                  }
                                  class="ct_img_32"
                                />
                              </div>
                              <div>
                                <h3 class="ct_fs_14 ct_fw_600 ct_text_dark mb-0">
                                  {item?.name || ""}
                                </h3>
                                <p class="ct_fs_12 ct_fw_400 ct_text_para mb-0">
                                  {item?.role || ""}
                                </p>
                              </div>
                            </div>

                            <div>
                              <h3 class="ct_fs_14 ct_fw_600 ct_text_dark mb-0">
                                {item?.efficiency_percent || 0}%
                              </h3>
                              <p class="ct_fs_12 ct_fw_400 ct_green_text mb-0">
                                Efficiency
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {analyticsData?.top_suppliers?.length && (
                    <div class="col-xl-4 col-md-6 mb-3">
                      <div class="ct_border_20 ct_p_20 ct_white_bg h-100 top-supplier-box">
                        <h3 class="ct_fs_16 ct_fw_600 ct_text_dark mb-3">
                          Top Suppliers
                        </h3>
                        {analyticsData?.top_suppliers?.map((item, index) => (
                          <div class="d-flex justify-content-between gap-2 align-items-center mb-3 flex-wrap">
                            <div class="d-flex gap-2 align-items-center">
                              <div>
                                <img
                                  src={item?.profile_image || "user_profile.png"}
                                  class="ct_img_32"
                                />
                              </div>
                              <div>
                                <h3 class="ct_fs_14 ct_fw_600 ct_text_dark mb-0">
                                  {item?.name || ""}{" "}
                                </h3>
                                <p class="ct_fs_12 ct_fw_400 ct_text_para mb-0">
                                  {item?.location || ""}
                                </p>
                              </div>
                            </div>

                            <div>
                              <h3 class="ct_fs_14 ct_fw_600 ct_text_dark mb-0">
                                {item?.efficiency_percent || 0}%
                              </h3>
                              <p class="ct_fs_12 ct_fw_400 ct_green_text mb-0">
                                Efficiency
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
